import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import {
  ALLOWED_GROUPS,
  hasDashboardAccess,
  initKeycloak,
  signOut,
  userDisplayName,
  userEmail,
  userGroups,
} from "./auth/keycloak";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <div style={{
    minHeight: "100vh", display: "flex",
    alignItems: "center", justifyContent: "center",
    fontFamily: "Figtree, system-ui, sans-serif", color: "#475569",
  }}>Signing in…</div>,
);

function AccessDenied() {
  const email = userEmail();
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Figtree, system-ui, sans-serif",
        background: "#F8FAF9",
        padding: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "26rem",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
          borderRadius: "1rem",
          padding: "2rem",
          textAlign: "center",
          boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: "1.25rem", fontWeight: 800, color: "#111827" }}>
          You don't have access to this dashboard
        </h1>
        <p style={{ marginTop: ".75rem", fontSize: ".875rem", color: "#475569", lineHeight: 1.5 }}>
          You're signed in as <strong>{userDisplayName()}</strong>
          {email ? <> ({email})</> : null}, but this account isn't in a
          group that's allowed to view timesheet compliance. If you think
          you should have access, ask an administrator to add you to the
          right dashboard group.
        </p>
        <button
          type="button"
          onClick={signOut}
          style={{
            marginTop: "1.25rem",
            fontSize: ".8125rem",
            fontWeight: 600,
            color: "#374151",
            backgroundColor: "#FFFFFF",
            border: "1px solid #CBD5E1",
            borderRadius: "9999px",
            padding: ".45rem 1.1rem",
            cursor: "pointer",
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

initKeycloak()
  .then((ok) => {
    if (!ok) {
      root.render(<div style={{ padding: "2rem" }}>Not signed in.</div>);
      return;
    }
    if (!hasDashboardAccess()) {
      // Leave a breadcrumb for debugging access problems: what the
      // token actually carried vs. what the gate requires. An empty
      // list means Keycloak isn't putting group membership in the
      // token at all — the DASH-LOGIN client needs a Group Membership
      // mapper (claim name "groups", added to the access token).
      console.warn(
        "[timesheet-compliance] Access denied.",
        "Groups/roles found in token:", Array.from(userGroups()),
        "Allowed groups:", ALLOWED_GROUPS,
      );
      root.render(<React.StrictMode><AccessDenied /></React.StrictMode>);
      return;
    }
    root.render(<React.StrictMode><App /></React.StrictMode>);
  })
  .catch((e) => {
    root.render(
      <div style={{ padding: "2rem", color: "#b91c1c", fontFamily: "Figtree, sans-serif" }}>
        <strong>Could not reach Keycloak.</strong>
        <pre style={{ whiteSpace: "pre-wrap", marginTop: ".5rem" }}>{String(e)}</pre>
      </div>,
    );
  });
